import { createFileRoute } from '@tanstack/react-router'
import Footer from '@/components/Footer'
import Header from '@/components/Header'

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
})

function PrivacyPage() {
  const lastUpdated = '1 March 2026'

  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 dark:bg-neutral-950">
      <Header />
      <main
        id="main-content"
        className="mx-auto w-full max-w-4xl flex-1 px-4 py-10 md:px-8"
      >
        <article className="rounded-2xl border bg-white p-6 shadow-sm dark:border-neutral-800 dark:bg-neutral-900 md:p-8">
          <h1 className="text-3xl font-bold text-neutral-900 dark:text-neutral-100">
            Privacy policy
          </h1>
          <p className="mt-2 text-sm text-neutral-500">
            Last updated: {lastUpdated}
          </p>

          <section className="mt-6 space-y-3 text-sm leading-7 text-neutral-700 dark:text-neutral-300">
            <p>
              We process account, billing, and chat data to deliver the
              BuildingRegs.app service. We use this information to authenticate
              users, process subscriptions, and provide cited answers.
            </p>
            <p>
              Data is stored using our managed infrastructure providers. Access
              is restricted to authorized personnel and service integrations.
            </p>
            <p>
              For data requests or privacy concerns, contact
              support@buildingregs.app.
            </p>
          </section>
        </article>
      </main>
      <Footer />
    </div>
  )
}
